import DeleteMessageModal from './DeleteMessageModal';

export default DeleteMessageModal;
